import React, { MouseEvent } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import AutomaticIcon from '@mui/icons-material/AutoFixHigh';
import { Box, Button, Tooltip } from '@mui/material';

import { CardinalDirection } from '../../library/layout-geometry/directions';

interface BaseProps {
  value: CardinalDirection | null;
  disabled?: boolean;
  onChange(event: MouseEvent, value: CardinalDirection): void;
}

interface AutomaticModeProps extends BaseProps {
  /** if set, an explicit "automatic mode" button will be displayed for the null value. defaults to false */
  automaticMode: true;
  onChange(event: MouseEvent, value: CardinalDirection | null): void;
}

interface ManualModeProps extends BaseProps {
  automaticMode?: false;
}

type Props = AutomaticModeProps | ManualModeProps;

export function DirectionButtons(props: Props) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, max-content)',
        gridTemplateRows: props.automaticMode ? 'repeat(3, 1fr)' : 'repeat(4, 1fr)',
        gap: 0,
      }}
    >
      <Button
        variant={props.value === 'up' ? 'contained' : undefined}
        disabled={props.disabled}
        onClick={(event) => props.onChange(event, 'up')}
        sx={{ gridRow: props.automaticMode ? 1 : '1 / span 2', gridColumn: 2 }}
      >
        <ArrowUpwardIcon />
      </Button>

      <Button
        variant={props.value === 'left' ? 'contained' : undefined}
        disabled={props.disabled}
        onClick={(event) => props.onChange(event, 'left')}
        sx={{ gridRow: props.automaticMode ? 2 : '2 / span 2', gridColumn: 1 }}
      >
        <ArrowBackIcon />
      </Button>

      {props.automaticMode && (
        <Tooltip title="Automatic">
          <Button
            variant={props.value === null ? 'contained' : undefined}
            disabled={props.disabled}
            onClick={(event) => {
              props.onChange(event, null);
            }}
            sx={{ gridRow: 2, gridColumn: 2 }}
          >
            <AutomaticIcon />
          </Button>
        </Tooltip>
      )}

      <Button
        variant={props.value === 'right' ? 'contained' : undefined}
        disabled={props.disabled}
        onClick={(event) => props.onChange(event, 'right')}
        sx={{ gridRow: props.automaticMode ? 2 : '2 / span 2', gridColumn: 3 }}
      >
        <ArrowForwardIcon />
      </Button>

      <Button
        variant={props.value === 'down' ? 'contained' : undefined}
        disabled={props.disabled}
        onClick={(event) => props.onChange(event, 'down')}
        sx={{ gridRow: props.automaticMode ? 3 : '3 / span 2', gridColumn: 2 }}
      >
        <ArrowDownwardIcon />
      </Button>
    </Box>
  );
}
